"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _getFeatureDescriptionKey = _interopRequireDefault(require("self-service-api/core/utilities/getFeatureDescriptionKey"));

var Hubs = _interopRequireWildcard(require("self-service-api/constants/Hubs"));

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 10px 0;\n  display: inline-block;\n\n  & > p {\n    margin-left: 8px;\n    margin-bottom: 0;\n    font-weight: 500;\n    display: inline-block;\n  }\n  text-align: left;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FeatureName = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteCatalogTableCell__FeatureName",
  componentId: "sc-1pkv6nx-0"
})(_templateObject());

var GrowthSuiteCatalogTableCell = function GrowthSuiteCatalogTableCell(_ref) {
  var merchandiseId = _ref.merchandiseId,
      featureId = _ref.featureId,
      hub = _ref.hub;
  var feature = _ImmutableMerchandiseIdMap.default[merchandiseId].features[featureId];
  var shortLimitContent = feature && feature.shortLimitKey ? _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "pricing-pages.shortLimits." + feature.shortLimitKey
  })) : null;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("td", {
    style: {
      width: '3%',
      textAlign: 'right'
    }
  }, featureId && _react.default.createElement(_UIIcon.default, {
    name: "success",
    style: {
      display: 'inline-block'
    }
  })), _react.default.createElement("td", {
    style: {
      width: '27%'
    }
  }, _react.default.createElement(FeatureName, null, featureId && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("p", {
    style: {
      cursor: 'help'
    }
  }, _react.default.createElement(_UITooltip.default, {
    placement: "right",
    title: _react.default.createElement(_FormattedMessage.default, {
      message: (0, _getFeatureDescriptionKey.default)(featureId, hub)
    })
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricing-pages.features." + featureId + ".name"
  })))))), _react.default.createElement("td", {
    style: {
      width: '20%'
    }
  }, shortLimitContent));
};

GrowthSuiteCatalogTableCell.propTypes = {
  featureId: _propTypes.default.string,
  merchandiseId: _propTypes.default.number.isRequired,
  hub: _propTypes.default.oneOf(Object.keys(Hubs).map(function (hubKey) {
    return Hubs[hubKey];
  })).isRequired
};
var _default = GrowthSuiteCatalogTableCell;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-catalog/GrowthSuiteCatalogTableCell.js
// module id = 862
// module chunks = 5 6